// TODO: Remove `./miraClient` and move contents to this file when all
// imports have been updated.
import miraClient from './miraClient';
export default miraClient;
